import React from 'react';

// Lists a tenant's rooms so the user can open one at /{tenant}/{room}. Only shown when a tenant has more
// than one room (a single-room tenant opens directly — see App's TenantEntry).
const RoomPicker = ({ tenant, rooms }) => (
  <div className="container p-3">
    <h5 className="mb-3">Habitaciones de {tenant}</h5>
    <div className="list-group">
      {rooms.map(r => (
        <a key={r.slug} className="list-group-item list-group-item-action" href={`/${tenant}/${r.slug}`}>
          {r.name} {!r.isActive && <span className="badge bg-secondary ms-2">inactiva</span>}
        </a>
      ))}
    </div>
  </div>
);

export default RoomPicker;
